import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  const msg =
    'Missing Supabase env vars (VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY).\n\n' +
    'Local dev: copy web/.env.example → web/.env (scripts/gen_secrets.sh does this\n' +
    'and fills the anon key), then restart the dev server.'
  // Surface it on the page instead of a blank white screen.
  if (typeof document !== 'undefined' && document.body) {
    document.body.innerHTML =
      '<pre style="padding:2rem;font:14px/1.5 ui-monospace,monospace;color:#c00;white-space:pre-wrap">' +
      msg +
      '</pre>'
  }
  throw new Error(msg)
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
})
